// This regex will match sentences that ends with . ? !
// only if the next sentence starts with a capital letter
//
// Example:
//
// Finding deals is our thing. This promo code was gathered from the internet. This deal is subject to availability,
// and Michaels terms, conditions, and exclusions may apply. Check Michaels website for more details. Deals change often.
// So apply this promo code during checkout to see if it works.
//
// Will match:
//
// Finding deals is our thing.
// This promo code was gathered from the internet.
// This deal is subject to availability, and Michaels terms, conditions, and exclusions may apply.
// Check Michaels website for more details.
// Deals change often. <-- the last segment 'sentence' that match this regex is the one before last of our incoming text
const sentenceBreakRegex = /([.?!])\s*(?=[A-Z])/g

export const setOnlyOneSpaceBetweenSentences = (text: string): string => {
  const sentences = text.replace(sentenceBreakRegex, '$1 |').split('|')
  return sentences.join('').trim()
}

export const getNearestSentenceBreakIndex = (
  text: string,
  maxLength: number
): number => {
  // break text in sentences
  const sentences = text.replace(sentenceBreakRegex, '$1 |').split('|')

  // if maxLength 0 we return -1
  if (maxLength <= 0) {
    return -1
  }

  // we loop through all the sentences to find the substring maxLength
  // where the text need to break
  let breakIndex = 0
  let indexToTest = 0
  let minDistance = maxLength - breakIndex
  for (let i = 0; i < sentences.length; i++) {
    indexToTest = indexToTest + sentences[i].length
    if (Math.abs(maxLength - indexToTest) < minDistance) {
      minDistance = Math.abs(maxLength - indexToTest)
      breakIndex = indexToTest
    }
  }

  return breakIndex
}
